import React, { useState, useCallback } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { useApi } from '@backstage/core-plugin-api';
import Alert from '@material-ui/lab/Alert';
import { useAsyncFn } from 'react-use';
import { Octokit } from '@octokit/rest';
import { useUrl } from '../useUrl.esm.js';
import { scmAuthApiRef } from '@backstage/integration-react';

const useStyles = makeStyles(
  (theme) => createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120
    },
    dialog: {
      minWidth: "300px"
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    label: {
      color: "inherit"
    }
  })
);
const UpdateSeverityStatusModal = ({
  owner,
  repo,
  severityData,
  id,
  tableData,
  setTableData,
  entity
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [dismissedReason, setDismissedReason] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const scmAuth = useApi(scmAuthApiRef);
  const { baseUrl, hostname } = useUrl(entity);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [state, dissmiss] = useAsyncFn(async (reason) => {
    if (reason.length === 0) return setErrorMsg("Field required");
    const credentials = await scmAuth.getCredentials({
      additionalScope: {
        customScopes: { github: ["repo"] }
      },
      url: `https://${hostname}`,
      optional: true
    });
    const octokit = new Octokit({ auth: credentials.token });
    const response = await octokit.request(
      "PATCH /repos/{owner}/{repo}/code-scanning/alerts/{alert_number}",
      {
        baseUrl,
        owner: "RoadieHQ",
        repo: "backstage",
        alert_number: id,
        state: "dismissed",
        dismissed_reason: reason
      }
    );
    const data = response.data;
    handleClose();
    setTableData(
      tableData.map(
        (element) => element.number === id ? { ...element, state: "dismissed" } : element
      )
    );
    return data;
  }, []);
  const getSeverityState = useCallback(
    (severityState) => {
      switch (severityState) {
        case "open":
          return /* @__PURE__ */ React.createElement(
            Chip,
            {
              label: "Open",
              color: "primary",
              variant: "outlined",
              size: "small",
              classes: {
                label: classes.label
              },
              onClick: handleClickOpen
            }
          );
        case "dismissed":
          return /* @__PURE__ */ React.createElement(
            Chip,
            {
              label: "Dismissed",
              color: "secondary",
              variant: "outlined",
              size: "small",
              classes: {
                label: classes.label
              }
            }
          );
        case "fixed":
          return /* @__PURE__ */ React.createElement(
            Chip,
            {
              label: "Fixed",
              color: "primary",
              variant: "outlined",
              size: "small",
              classes: {
                label: classes.label
              }
            }
          );
        default:
          return "Unknown";
      }
    },
    []
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, getSeverityState(severityData), /* @__PURE__ */ React.createElement(
    Dialog,
    {
      open,
      keepMounted: true,
      onClose: handleClose,
      "aria-labelledby": "alert-dialog-slide-title",
      "aria-describedby": "alert-dialog-slide-description",
      fullWidth: true
    },
    /* @__PURE__ */ React.createElement(DialogTitle, { id: "alert-dialog-slide-title" }, "Dismiss severity #", id),
    /* @__PURE__ */ React.createElement(DialogContent, null, state.error && /* @__PURE__ */ React.createElement(Box, { mb: 3 }, /* @__PURE__ */ React.createElement(Alert, { severity: "error" }, state.error.message)), /* @__PURE__ */ React.createElement(
      FormControl,
      {
        error: Boolean(errorMsg),
        className: classes.formControl
      },
      /* @__PURE__ */ React.createElement(InputLabel, { id: "dissmis-type-select-error-label" }, "Dismiss type"),
      /* @__PURE__ */ React.createElement(
        Select,
        {
          labelId: "dissmis-type-select-error-label",
          id: "dissmis-type",
          value: dismissedReason,
          onChange: (e) => {
            setErrorMsg("");
            setDismissedReason(e.target.value);
          },
          autoWidth: true
        },
        /* @__PURE__ */ React.createElement(MenuItem, { value: "false positive" }, "False positive"),
        /* @__PURE__ */ React.createElement(MenuItem, { value: "won't fix" }, "Won't fix"),
        /* @__PURE__ */ React.createElement(MenuItem, { value: "used in tests" }, "Used in tests")
      ),
      /* @__PURE__ */ React.createElement(FormHelperText, null, errorMsg)
    )),
    /* @__PURE__ */ React.createElement(DialogActions, null, /* @__PURE__ */ React.createElement(Button, { onClick: handleClose, variant: "contained", color: "secondary" }, "Close"), /* @__PURE__ */ React.createElement(
      Button,
      {
        onClick: () => dissmiss(dismissedReason),
        variant: "contained",
        color: "primary"
      },
      "Confirm"
    ))
  ));
};

export { UpdateSeverityStatusModal };
//# sourceMappingURL=UpdateSeverityStatusModal.esm.js.map
